import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { getMap, iniMap } from './mapInstance';
import { baseLayer } from './assets';

const useStyles = makeStyles((theme) => ({
	map: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        '& .ol-zoom': {
            bottom: 'unset',
            top: '12em',
        }
	}
}));

const MapContainer = () => {

    const classes = useStyles();

    useEffect(() => {

        iniMap();
        getMap().addLayer(baseLayer);
    }, []);


    return <div>
        <div id="map" className={classes.map}></div>
        <div id="popup"></div>
    </div>;
}

export default MapContainer;


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/letera/src/features/map/container.js